module.exports = __webpack_public_path__ + "img/News.33411842.png";